export default "__VITE_ASSET__C6iOi5JO__";